import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Maximize2, Minimize2, X } from "lucide-react";

export default function PresentationControls({ controller, autoHide = true }) {
  const [visible, setVisible] = useState(true);
  const hideTimerRef = useRef(null);
  const revealTemporarily = () => {
    setVisible(true);
    if (hideTimerRef.current) window.clearTimeout(hideTimerRef.current);
    if (autoHide) hideTimerRef.current = window.setTimeout(() => setVisible(false), 2200);
  };

  useEffect(() => {
    if (!controller.active) return undefined;
    revealTemporarily();
    const revealNearControls = (event) => {
      if (event.clientY >= window.innerHeight - 120) revealTemporarily();
    };
    if (autoHide) document.addEventListener("pointermove", revealNearControls, { passive: true });
    return () => {
      document.removeEventListener("pointermove", revealNearControls);
      if (hideTimerRef.current) window.clearTimeout(hideTimerRef.current);
    };
  }, [autoHide, controller.active, controller.currentIndex, controller.fullscreen]);

  if (!controller.active) return null;
  const guided = controller.mode === "guided";
  return <div onMouseEnter={revealTemporarily} onFocusCapture={revealTemporarily} className={`absolute bottom-4 left-1/2 z-60 flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-1 rounded-lg border border-[#d3d6d9] bg-[#fcfbfa] p-1.5 font-sans shadow-[0_8px_24px_rgba(20,24,30,0.08)] transition-opacity duration-200 ${!autoHide || visible ? "opacity-100" : "opacity-0"}`} role="toolbar" aria-label="Presentation controls">
    {guided && <>
      <button type="button" onClick={controller.previous} disabled={controller.currentIndex === 0} className="grid h-9 w-9 place-items-center rounded-md text-[#52565b] hover:bg-[#f2f3f4] disabled:opacity-35" aria-label="Previous view"><ChevronLeft size={18} /></button>
      <span className="min-w-18 px-2 text-center text-xs font-semibold tabular-nums text-[#30343a]" aria-live="polite">{controller.currentIndex + 1} / {controller.stops.length}</span>
      <button type="button" onClick={controller.next} disabled={controller.currentIndex >= controller.stops.length - 1} className="grid h-9 w-9 place-items-center rounded-md text-[#52565b] hover:bg-[#f2f3f4] disabled:opacity-35" aria-label="Next view"><ChevronRight size={18} /></button>
      <span className="mx-1 h-6 border-l border-[#d3d6d9]" aria-hidden="true" />
    </>}
    <button type="button" onClick={controller.toggleFullscreen} className="grid h-9 w-9 place-items-center rounded-md text-[#52565b] hover:bg-[#f2f3f4]" aria-label={controller.fullscreen ? "Exit fullscreen" : "Enter fullscreen"}>{controller.fullscreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}</button>
    <button type="button" onClick={controller.exit} className="grid h-9 w-9 place-items-center rounded-md text-[#30343a] hover:bg-[#f2f3f4]" aria-label="Exit presentation"><X size={17} /></button>
  </div>;
}
